
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as adm_45002y7GLpHb8ylMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-002.vue?macro=true";
import { default as adm_45003EuKNUy3T9UMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-003.vue?macro=true";
import { default as adm_45004mpKMUk6Pb1Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-004.vue?macro=true";
import { default as adm_45005_451bUmd1QihF5Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-005-1.vue?macro=true";
import { default as adm_45005abzsk00JobMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-005.vue?macro=true";
import { default as adm_45007YYN0Yre3gOMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-007.vue?macro=true";
import { default as adm_4500888LYqOUyAMMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-008.vue?macro=true";
import { default as adm_45009UiNzgxmNbOMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-009.vue?macro=true";
import { default as adm_45010K6DM4ZTMw7Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-010.vue?macro=true";
import { default as adm_45011etULQCJzI1Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-011.vue?macro=true";
import { default as adm_45012KgrcHc7GgfMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-012.vue?macro=true";
import { default as adm_45013_45dialogOuJ1mrvw3cMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-013-dialog.vue?macro=true";
import { default as adm_45013QnbEpzbhgJMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-013.vue?macro=true";
import { default as adm_45014eTcaJAbfTXMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-014.vue?macro=true";
import { default as adm_45015vRQ49yh2R7Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-015.vue?macro=true";
import { default as adm_45016wOFMIIXAVkMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-016.vue?macro=true";
import { default as adm_45017ReIRVtxzzXMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-017.vue?macro=true";
import { default as adm_450184WI3bnMaJvMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-018.vue?macro=true";
import { default as adm_45020Mgwsj5wQdfMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-020.vue?macro=true";
import { default as adm_45021pG0lpItKy4Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-021.vue?macro=true";
import { default as adm_45022CKGCRdLuSnMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-022.vue?macro=true";
import { default as adm_45023f2zH8103dOMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-023.vue?macro=true";
import { default as adm_45024LPvB6Og1gfMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-024.vue?macro=true";
import { default as adm_450251YxbArOcvxMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-025.vue?macro=true";
import { default as adm_450260IHFvUfdyVMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-026.vue?macro=true";
import { default as adm_45027pHNnCvVkD7Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-027.vue?macro=true";
import { default as adm_450283mbaJccvYPMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-028.vue?macro=true";
import { default as adm_45029ToLPfHYLKHMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-029.vue?macro=true";
import { default as adm_450305byeY2RtUNMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-030.vue?macro=true";
import { default as adm_450313iulmn9SQaMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-031.vue?macro=true";
import { default as adm_45032V6uhG9vHnhMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-032.vue?macro=true";
import { default as adm_45dummeCQQZV8Yh5zMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-dumme.vue?macro=true";
import { default as adm_45tab005oEVW6ugZzAMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-tab005.vue?macro=true";
import { default as adm_45tab006Ky6A5ileNnMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-tab006.vue?macro=true";
import { default as loginPyNNK7WTKpMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/login.vue?macro=true";
import { default as component_45sample2QQoQAfotKMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/component/component-sample.vue?macro=true";
import { default as errorpP0qQbo6MFMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/error.vue?macro=true";
import { default as indexT8bamUnLjIMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/index.vue?macro=true";
import { default as loginAmJGeGxLL0Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/login.vue?macro=true";
import { default as prop_45002DtZ5jGruvyMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-002.vue?macro=true";
import { default as prop_45003oWuwDQ1x8DMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-003.vue?macro=true";
import { default as prop_450045KXrUV07IqMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-004.vue?macro=true";
import { default as prop_450053Tw2Ovepx8Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-005.vue?macro=true";
import { default as prop_45006ELTzpzIZwAMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-006.vue?macro=true";
import { default as prop_45007eIrc13ApvqMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-007.vue?macro=true";
import { default as prop_450082LT76Ne84gMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-008.vue?macro=true";
import { default as prop_450097JJIKCwgcWMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-009.vue?macro=true";
import { default as prop_45011oZ6oVEEh9wMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-011.vue?macro=true";
import { default as prop_450126dawIRJK08Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-012.vue?macro=true";
import { default as prop_45013CRpQKSIvKpMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-013.vue?macro=true";
import { default as prop_45014LQE3el6FBvMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-014.vue?macro=true";
import { default as prop_45015k1yWYXQKG5Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-015.vue?macro=true";
import { default as prop_45016U70jSZKNtsMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-016.vue?macro=true";
import { default as prop_45017Y30HCXru6JMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-017.vue?macro=true";
import { default as prop_45018UsxHoSdf78Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-018.vue?macro=true";
import { default as prop_45019whhox5rBU7Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-019.vue?macro=true";
import { default as prop_450200nwaZmhaTcMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-020.vue?macro=true";
import { default as prop_45021CmXlnZxq1FMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-021.vue?macro=true";
import { default as prop_45022_4502NQum1bvoAlMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-022-02.vue?macro=true";
import { default as prop_45022nwHAp5TobJMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-022.vue?macro=true";
import { default as prop_45023_45010NJcrwLKPiMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-023-01.vue?macro=true";
import { default as prop_45023_4502bzsjR7ZdyuMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-023-02.vue?macro=true";
import { default as prop_45024_4502T4tDJTUs0BMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-024-02.vue?macro=true";
import { default as prop_45024ChXcCQFiHkMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-024.vue?macro=true";
import { default as prop_45025_4502TeEcfKTcCZMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-025-02.vue?macro=true";
import { default as prop_45025xGNe2eushrMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-025.vue?macro=true";
import { default as prop_45026ofoRLqQ2qFMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-026.vue?macro=true";
import { default as prop_450279Eau4x7zXvMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-027.vue?macro=true";
import { default as prop_45028twPaVbyyX1Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-028.vue?macro=true";
import { default as prop_45029jtFqc6OlC4Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-029.vue?macro=true";
import { default as prop_45030KtM5KfdZl3Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-030.vue?macro=true";
import { default as prop_45031Wb4OoDfMVJMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-031.vue?macro=true";
import { default as prop_45032EKl96tbSB8Meta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-032.vue?macro=true";
import { default as prop_45033DEcQto7RduMeta } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-033.vue?macro=true";
export default [
  {
    name: "admin-adm-002",
    path: "/admin/adm-002",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-002.vue")
  },
  {
    name: "admin-adm-003",
    path: "/admin/adm-003",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-003.vue")
  },
  {
    name: "admin-adm-004",
    path: "/admin/adm-004",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-004.vue")
  },
  {
    name: "admin-adm-005-1",
    path: "/admin/adm-005-1",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-005-1.vue")
  },
  {
    name: "admin-adm-005",
    path: "/admin/adm-005",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-005.vue")
  },
  {
    name: "admin-adm-007",
    path: "/admin/adm-007",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-007.vue")
  },
  {
    name: "admin-adm-008",
    path: "/admin/adm-008",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-008.vue")
  },
  {
    name: "admin-adm-009",
    path: "/admin/adm-009",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-009.vue")
  },
  {
    name: "admin-adm-010",
    path: "/admin/adm-010",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-010.vue")
  },
  {
    name: "admin-adm-011",
    path: "/admin/adm-011",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-011.vue")
  },
  {
    name: "admin-adm-012",
    path: "/admin/adm-012",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-012.vue")
  },
  {
    name: "admin-adm-013-dialog",
    path: "/admin/adm-013-dialog",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-013-dialog.vue")
  },
  {
    name: "admin-adm-013",
    path: "/admin/adm-013",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-013.vue")
  },
  {
    name: "admin-adm-014",
    path: "/admin/adm-014",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-014.vue")
  },
  {
    name: "admin-adm-015",
    path: "/admin/adm-015",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-015.vue")
  },
  {
    name: "admin-adm-016",
    path: "/admin/adm-016",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-016.vue")
  },
  {
    name: "admin-adm-017",
    path: "/admin/adm-017",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-017.vue")
  },
  {
    name: "admin-adm-018",
    path: "/admin/adm-018",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-018.vue")
  },
  {
    name: "admin-adm-020",
    path: "/admin/adm-020",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-020.vue")
  },
  {
    name: "admin-adm-021",
    path: "/admin/adm-021",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-021.vue")
  },
  {
    name: "admin-adm-022",
    path: "/admin/adm-022",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-022.vue")
  },
  {
    name: "admin-adm-023",
    path: "/admin/adm-023",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-023.vue")
  },
  {
    name: "admin-adm-024",
    path: "/admin/adm-024",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-024.vue")
  },
  {
    name: "admin-adm-025",
    path: "/admin/adm-025",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-025.vue")
  },
  {
    name: "admin-adm-026",
    path: "/admin/adm-026",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-026.vue")
  },
  {
    name: "admin-adm-027",
    path: "/admin/adm-027",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-027.vue")
  },
  {
    name: "admin-adm-028",
    path: "/admin/adm-028",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-028.vue")
  },
  {
    name: "admin-adm-029",
    path: "/admin/adm-029",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-029.vue")
  },
  {
    name: "admin-adm-030",
    path: "/admin/adm-030",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-030.vue")
  },
  {
    name: "admin-adm-031",
    path: "/admin/adm-031",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-031.vue")
  },
  {
    name: "admin-adm-032",
    path: "/admin/adm-032",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-032.vue")
  },
  {
    name: "admin-adm-dumme",
    path: "/admin/adm-dumme",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-dumme.vue")
  },
  {
    name: "admin-adm-tab005",
    path: "/admin/adm-tab005",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-tab005.vue")
  },
  {
    name: "admin-adm-tab006",
    path: "/admin/adm-tab006",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/adm-tab006.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/admin/login.vue")
  },
  {
    name: "component-component-sample",
    path: "/component/component-sample",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/component/component-sample.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: errorpP0qQbo6MFMeta || {},
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/index.vue")
  },
  {
    name: "property-manager-login",
    path: "/property-manager/login",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/login.vue")
  },
  {
    name: "property-manager-prop-002",
    path: "/property-manager/prop-002",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-002.vue")
  },
  {
    name: "property-manager-prop-003",
    path: "/property-manager/prop-003",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-003.vue")
  },
  {
    name: "property-manager-prop-004",
    path: "/property-manager/prop-004",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-004.vue")
  },
  {
    name: "property-manager-prop-005",
    path: "/property-manager/prop-005",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-005.vue")
  },
  {
    name: "property-manager-prop-006",
    path: "/property-manager/prop-006",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-006.vue")
  },
  {
    name: "property-manager-prop-007",
    path: "/property-manager/prop-007",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-007.vue")
  },
  {
    name: "property-manager-prop-008",
    path: "/property-manager/prop-008",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-008.vue")
  },
  {
    name: "property-manager-prop-009",
    path: "/property-manager/prop-009",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-009.vue")
  },
  {
    name: "property-manager-prop-011",
    path: "/property-manager/prop-011",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-011.vue")
  },
  {
    name: "property-manager-prop-012",
    path: "/property-manager/prop-012",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-012.vue")
  },
  {
    name: "property-manager-prop-013",
    path: "/property-manager/prop-013",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-013.vue")
  },
  {
    name: "property-manager-prop-014",
    path: "/property-manager/prop-014",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-014.vue")
  },
  {
    name: "property-manager-prop-015",
    path: "/property-manager/prop-015",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-015.vue")
  },
  {
    name: "property-manager-prop-016",
    path: "/property-manager/prop-016",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-016.vue")
  },
  {
    name: "property-manager-prop-017",
    path: "/property-manager/prop-017",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-017.vue")
  },
  {
    name: "property-manager-prop-018",
    path: "/property-manager/prop-018",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-018.vue")
  },
  {
    name: "property-manager-prop-019",
    path: "/property-manager/prop-019",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-019.vue")
  },
  {
    name: "property-manager-prop-020",
    path: "/property-manager/prop-020",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-020.vue")
  },
  {
    name: "property-manager-prop-021",
    path: "/property-manager/prop-021",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-021.vue")
  },
  {
    name: "property-manager-prop-022-02",
    path: "/property-manager/prop-022-02",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-022-02.vue")
  },
  {
    name: "property-manager-prop-022",
    path: "/property-manager/prop-022",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-022.vue")
  },
  {
    name: "property-manager-prop-023-01",
    path: "/property-manager/prop-023-01",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-023-01.vue")
  },
  {
    name: "property-manager-prop-023-02",
    path: "/property-manager/prop-023-02",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-023-02.vue")
  },
  {
    name: "property-manager-prop-024-02",
    path: "/property-manager/prop-024-02",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-024-02.vue")
  },
  {
    name: "property-manager-prop-024",
    path: "/property-manager/prop-024",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-024.vue")
  },
  {
    name: "property-manager-prop-025-02",
    path: "/property-manager/prop-025-02",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-025-02.vue")
  },
  {
    name: "property-manager-prop-025",
    path: "/property-manager/prop-025",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-025.vue")
  },
  {
    name: "property-manager-prop-026",
    path: "/property-manager/prop-026",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-026.vue")
  },
  {
    name: "property-manager-prop-027",
    path: "/property-manager/prop-027",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-027.vue")
  },
  {
    name: "property-manager-prop-028",
    path: "/property-manager/prop-028",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-028.vue")
  },
  {
    name: "property-manager-prop-029",
    path: "/property-manager/prop-029",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-029.vue")
  },
  {
    name: "property-manager-prop-030",
    path: "/property-manager/prop-030",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-030.vue")
  },
  {
    name: "property-manager-prop-031",
    path: "/property-manager/prop-031",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-031.vue")
  },
  {
    name: "property-manager-prop-032",
    path: "/property-manager/prop-032",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-032.vue")
  },
  {
    name: "property-manager-prop-033",
    path: "/property-manager/prop-033",
    component: () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/pages/property-manager/prop-033.vue")
  }
]